export const defaultSorted = [{ dataField: "date", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 },
];
export const initialFilter = {
  filter: {
    searchFilter: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "date",
  pageNumber: 1,
  pageSize: 10,
};
export const productionsType = [
  { value: "SUCCESSFUL", label: "Successful" },
  { value: "SCRAP", label: "Scrap" },
];

// Delete case
export const setNewQueryParams = (queryParams, totalCount, entities) => {
  const pageSize = queryParams.pageSize;
  const lastPageValue = (totalCount + pageSize - 1) / pageSize;
  const pageNumber = queryParams.pageNumber;
  const res = { isRequieredSetQueryParams: lastPageValue === pageNumber && entities.length - 1 === 0 };
  res.cleanRefFilters = totalCount === 1 ? true: false;
  if (res.isRequieredSetQueryParams) {
      res.queryParams = totalCount === 1 ? {...initialFilter} : { ...queryParams, pageNumber: lastPageValue - 1 };
  }
  return res;
};